<template>
  <div class="page-container">
    <!-- Кривая линия -->
    <div class="curve-line" v-if="showCurve">
      <svg class="curve-svg" viewBox="0 0 100 1000" preserveAspectRatio="none">
        <path class="curve-path" d="M50,0 C70,50 30,150 50,200 C70,250 30,350 50,400 C70,450 30,550 50,600 C70,650 30,750 50,800 C70,850 30,950 50,1000" />
      </svg>
    </div>
    
    <main id="content" role="main">
      <!-- Page Title / Hero -->
      <section id="hero" aria-label="Hero section">
        <div class="container">
          <h2 class="page-title animate-element" ref="pageTitle">{{ $t('bio.start')}}</h2>

          <!-- Optional background/gallery images (two images) -->
          <div class="silimed-banner animate-element" ref="silimedBanner">
            <img src="/img/inplants2.jpg" alt="Silimed">
          </div>

          <div class="silimed-buttons animate-element" ref="silimedButtons">
            <a href="#" @click="goToBiodesin">{{ $t('bio.bio')}}</a>
            <a href="#" @click="goToStandard">{{ $t('bio.stand')}}</a>
            <a href="#" @click="goToType">{{ $t('bio.type')}}</a>
          </div>
        </div>
      </section>

      <!-- Introductory text blocks (3–4 paragraphs) -->
      <section id="intro" aria-label="Вводная информация">
        <div class="container">
          <h2 class="visually-hidden animate-element" ref="introTitle">{{  $t('bio.title') }}</h2>
          <p class="visually-p animate-element" ref="introText">{{ $t('bio.technology')}}</p>
        </div>
      </section>

      <!-- Models grid (5 cards) -->
      <section id="models" aria-label="Модели и варианты">
        <div class="container">
          <h2 class="animate-element" ref="modelsTitle">{{ $t('bio.biodesign')}}</h2>
          <div class="grid grid-5">

            <!-- Card 1 -->
            <div class="card model animate-element" ref="card1">
              <img class="model-img" src="/img/cart/cart_main1.png" alt="" />
              <h3 class="card-title">{{ $t('bio.adva')}}</h3>
              <p class="card-subtitle">{{ $t('bio.profile')}}</p>
              <ul class="card-bullets">
                <li>{{ $t('bio.let')}}</li>
                <li>{{ $t('bio.let2')}}</li>
              </ul>
              <div class="card-availability">
                <p class="label">{{ $t('bio.types')}}</p>
                <ul class="chips">
                  <li class="chip red"></li>
                </ul>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="card model animate-element" ref="card2">
              <img class="model-img" src="/img/cart/cart_main2.png" alt="" />
              <h3 class="card-title">{{ $t('bio.natu')}}</h3>
              <p class="card-subtitle">{{ $t('bio.drops')}}</p>
              <ul class="card-bullets">
                <li>{{ $t('bio.nature') }}</li>
                <li>{{ $t('bio.nature2')}}</li>
              </ul>
              <div class="card-availability">
                <p class="label">{{ $t('bio.types')}}</p>
                <ul class="chips">
                  <li class="chip red"></li>
                  <li class="chip blue"></li>
                </ul>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="card model animate-element" ref="card3">
              <img class="model-img" src="/img/cart/cart_main3.png" alt="" />
              <h3 class="card-title">{{ $t('enha')}}</h3>
              <p class="card-subtitle">{{ $t('bio.oval')}}</p>
              <ul class="card-bullets">
                <li>{{ $t('bio.filled')}}</li>
                <li>{{ $t('bio.better')}}</li>
              </ul>
              <div class="card-availability">
                <p class="label">{{ $t('bio.types')}}</p>
                <ul class="chips">
                  <li class="chip red"></li>
                  <li class="chip blue"></li>
                </ul>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="card model animate-element" ref="card4">
              <img class="model-img" src="/img/cart/cart_main4.png" alt="" />
              <h3 class="card-title">{{ $t('bio.nuan')}}</h3>
              <p class="card-subtitle">{{ $t('bio.owal')}}</p>
              <ul class="card-bullets">
                <li>{{ $t('bio.bottom')}}</li>
                <li>{{  $t('bio.optimal') }}</li>
              </ul>
              <div class="card-availability">
                <p class="label">{{ $t('bio.types')}}</p>
                <ul class="chips">
                  <li class="chip red"></li>
                  <li class="chip blue"></li>
                </ul>
              </div>
            </div>

            <!-- Card 5 -->
            <div class="card model animate-element" ref="card5">
              <img class="model-img" src="/img/cart/cart_main5.png" alt="" />
              <h3 class="card-title">{{ $t('bio.max')}}</h3>
              <p class="card-subtitle">{{ $t('bio.spher')}}</p>
              <ul class="card-bullets">
                <li>{{ $t('bio.hi')}}</li>
                <li> {{ $t('bio.hi2')}}</li>
              </ul>
              <div class="card-availability">
                <p class="label">{{ $t('bio.types')}}</p>
                <ul class="chips">
                  <li class="chip red"></li>
                  <li class="chip blue"></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div class="cart-type-parag animate-element" ref="cartTypeParag">
            <p class="cart-type-p">{{ $t('bio.types')}}</p>
            <ul class="cart-type-ul">
              <li class="cart-type-li"><div class="red"></div> Pure Polyurethane</li>
              <li class="cart-type-li"><div class="blue"></div> True Texture</li>
            </ul>
          </div>
        </div>
      </section>

      <!-- Projection legend / variants (4 items) -->
      <section id="projections" aria-label="Варианты проекций">
        <div class="container">
          <h2 class="visually-hidden-h2-sec animate-element" ref="projectionTitle">{{ $t('bio.model')}}</h2>

          <ul class="projection-list">
            <li class="projection animate-element" ref="projection1">
              <img src="/img/cart-select/projection_img1.png" alt="" class="projection-img">
              <span class="tag">{{ $t('bio.xh')}}</span> 
            </li>
            <li class="projection animate-element" ref="projection2">
              <img src="/img/cart-select/projection_img2.png" alt="" class="projection-img">
              <span class="tag">{{ $t('bio.hii')}}</span> 
            </li>
            <li class="projection animate-element" ref="projection3">
              <img src="/img/cart-select/projection_img3.png" alt="" class="projection-img">
              <span class="tag">{{ $t('bio.md')}}</span> 
            </li>
            <li class="projection animate-element" ref="projection4">
              <img src="/img/cart-select/projection_img4.jpg" alt="" class="projection-img">
              <span class="tag">{{ $t('bio.lo')}}</span> 
            </li>
          </ul>

          <figure class="projection-figure animate-element" ref="projectionFigure">
            <figcaption>{{ $t('bio.photo')}}</figcaption>
          </figure>
        </div>
      </section>

      <!-- Catalog download CTA -->
      <section id="catalog-cta" aria-label="Скачать каталог">
        <div class="container">
          <!-- <a href="../assets/ydcueqzzlq0rmdpf2ecvhbejp3n8muc4.pdf" class="button primary animate-element" target="_blank" download="../assets/ydcueqzzlq0rmdpf2ecvhbejp3n8muc4.pdf" ref="catalogButton">Скачать каталог</a> -->
           <a href="/ydcueqzzlq0rmdpf2ecvhbejp3n8muc4.pdf" target="_blank" class="btn-vue">скачайте каталог</a>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'MainBiodesign',
  data() {
    return {
      showCurve: true
    }
  },
  setup() {
    const router = useRouter()

    function goToBiodesin() {
      router.push("/biodesain")
    }
    function goToStandard() {
      router.push("/standardline")
    }
    function goToType() {
      router.push("/type")
    }

    return { goToBiodesin, goToStandard, goToType }
  },
  mounted() {
    this.initAnimations();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 🔹 метод для перевода
    switchLang(lang) {
      this.$i18n.locale = lang
    },

    initAnimations() {
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line');
          if (curveLine) {
            curveLine.classList.add('animate-curve');
          }
        }, 100);
      }

      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        );
      };

      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element');
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate');
          }
        });
      };

      window.addEventListener('load', handleScroll);
      window.addEventListener('scroll', handleScroll);
      handleScroll();
    },

    handleResize() {
      this.showCurve = window.innerWidth > 768;
    }
  }
}
</script>


<style scoped>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.btn-vue {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-size: 20px;
  color: white;
  background-color: #108381;
  border: 1px solid white;
  width: 250px;
  height: 50px;
  transition: 300ms;
  cursor: pointer;
  text-decoration: none;
}

.btn-vue:hover {
  color: #108381;
  background-color: white;
  border: 1px solid #108381;
}

/* Контейнер для всей страницы с отступом */
.page-container {
  position: relative;
  max-width: 1200px;
  margin: 70px auto;
  padding: 0 20px;
}

.page-title {
  color: #525252;
  font-size: 36px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 10px;
  text-align: center;
  margin-bottom: 50px;
}

.container {
  text-align: left;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.visually-hidden{
  color: #0d1016;
  font-size: 30px;
  font-weight: 300;
  line-height: normal;
  margin-bottom: 25px;
}

#models h2 {
  padding: 0;
  font-weight: normal;
  color: #0d1016;
  font-size: 26px;
  font-weight: 300;
  line-height: normal;
  margin: 30px 0 0 !important;
}

.visually-p{
    font-weight: 200;
    line-height: 30px;
    margin-bottom: 25px;
    color: rgb(97, 97, 97);
    font-size: 18px;
}

.silimed-banner{
  margin-bottom: 30px;
  padding: 5px;
  border: 1px solid rgba(15, 131, 129, .14);
}

.silimed-banner img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}

.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  height: 100px;
  width: 100%;
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 76px;
  position: relative;
  width: calc(33.333% - 28px);
  margin: 15px 0;
  padding: 0 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}

.grid-5{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
  justify-content: center;
}

.card{
  color: #343635;
  position: relative;
  margin: 35px 0 0 32px;
  padding: 28px;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 49px rgba(151, 151, 151, .24);
  max-width: 350px;
  min-height: 480px;
}

.model-img{
  width: 200px;
  height: 150px;
  margin: auto;
}

.card-title{
  color: #343635;
  font-weight: 500;
  transition: .2s linear;
  text-decoration: none;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.card-subtitle{
  font-weight: 300;
  min-height: 20px;
  margin-bottom: 9px;
  font-size: 18px;
}

.card-bullets li {
  list-style: none;
}

.card-availability {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.chips {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  list-style: none;
}

.red {
  color: #ff8400;
  background: #ff8400;
  width: 20px;
  height: 20px; 
  border-radius: 50%;
}

.blue {
  color: #007bff;
  background: #007bff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.cart-type-parag {
  font-weight: 500;
  margin-bottom: 50px;
  padding: 12px 35px;
  background: #fafafa;
  align-items: center;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.cart-type-ul {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  list-style: none;
}

.cart-type-li{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.visually-hidden-h2-sec {
    color: #343635;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 50px;
}

.projection-list {
  display: flex;
  align-items: end;
  justify-content: center;
  gap: 20px;
  width: 100%;
  height: 190px;
}

.projection{
  width: calc(25% - 30px);
  margin: 30px 0 0 30px;
  text-align: center;
  list-style: none;
}

.tag{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #343635;
  font-weight: 500;
  transition: .2s linear;
  text-decoration: none;
}

.projection-figure {
  color: #343635;
  font-weight: 300;
  padding: 12px 35px;
  background: #fafafa;
  margin-top: 50px;
}

.primary {
  color: #343635;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 50px;
  text-decoration: none;
}

/* Анимационные стили */
.animate-element {
  transform: translateX(-100px);
  opacity: 0;
  transition: transform 0.8s ease-out, opacity 0.8s ease;
}

.animate {
  transform: translateX(0) !important;
  opacity: 1 !important;
}

/* Кривая линия - перемещена левее контента */
.curve-line {
  position: absolute;
  top: 0;
  left: -80px;
  width: 100px;
  height: 100%;
  z-index: -1;
}

.curve-svg {
  width: 100%;
  height: 100%;
}

.curve-path {
  fill: none;
  stroke: #0b8482;
  stroke-width: 2;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  transition: stroke-dashoffset 2s ease-in-out;
}

.animate-curve .curve-path {
  stroke-dashoffset: 0;
}

/* Адаптация для мобильных устройств */
@media (max-width: 768px) {
  .page-container {
    padding: 0 15px;
    margin: 40px auto;
  }
  
  .curve-line {
    display: none; /* Скрываем линию на мобильных */
  }
  
  .animate-element {
    transform: translateX(-50px); /* Меньшее смещение для мобильных */
  }
  
  .silimed-buttons {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }
  
  .silimed-buttons a {
    width: 100%;
    line-height: 50px;
  }
  
  .grid-5 {
    grid-template-columns: 1fr;
  }
  
  .card {
    max-width: 100%;
    margin: 20px 0;
  }
  
  .cart-type-parag {
    flex-direction: column;
    gap: 15px;
  }
  
  .cart-type-ul {
    flex-direction: column;
    gap: 15px;
  }
  
  .projection-list {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  
  .projection {
    width: 100%;
    margin: 15px 0;
  }
}
</style>